import { Component, QueryList, ViewChildren } from "@angular/core";
import {
  Platform,
  AlertController,
  IonRouterOutlet,
} from "@ionic/angular";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { AngularFireAuth } from "@angular/fire/auth";
import { NavController } from "@ionic/angular";
import { Router } from "@angular/router";
import { UserService } from "./services/user.service";
import { Plugins } from '@capacitor/core';

const { SplashScreen } = Plugins;

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

  backButtonSubscription;
  profileInfo;
  navLinksArray: any;
  isRoot: boolean = false;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private navController: NavController,
    public ngFireAuth: AngularFireAuth,
    private router: Router,
    private userService: UserService,
    private alertController: AlertController
  ){}

  ngOnInit() {
    this.initializeApp();
    this.ionViewDidEnter();
  }

  ionViewDidEnter() {
    document.addEventListener("backbutton", () => {
      this.routerOutlets.forEach((outlet: IonRouterOutlet) => {
        if (this.router.url === "/main/dashboard") {
          this.quitVerify();
        } else if (this.router.url === "/login") {
          this.quitVerify();
        } else if (this.router.url === "/home") {
          this.quitVerify();
        } else if (outlet.getLastUrl() == "/main") {
          this.router.navigateByUrl("main/dashboard");
        } else if (outlet.getLastUrl() == "/notification") {
          this.router.navigateByUrl("main/dashboard");
        } else if (outlet.getLastUrl() == "/manage-personal-activity") {
          this.router.navigateByUrl("main/activity");
        } else if (outlet.getLastUrl() == "/user-info-form") {
          if (this.profileInfo.bloodtype != undefined || "") {
            this.router.navigateByUrl("main/profile");
          } else {
            this.router.navigateByUrl("login");
          }
        }
      });
    });
  }

  async quitVerify() {
    const alert = await this.alertController.create({
      message: "Are you sure you want to close the application?",
      buttons: [
        {
          text: "Yes",
          handler: (value) => {
            navigator["app"].exitApp();
          },
        },
        {
          text: "No",
        },
      ],
    });
    await alert.present();
  }

  async initializeApp(): Promise<any> {
    await this.platform.ready().then(() => {
      setTimeout(function() {
        SplashScreen.hide();
      }, 1000);
      this.statusBar.styleDefault();
      this.ngFireAuth.authState.pipe().subscribe((user) => {
        if (user) {
          if (
            user.emailVerified ||
            user.providerData.some((pd) => pd.providerId == "facebook.com")
          ) {
            //this.getProfileInfo();
            this.router.navigateByUrl("main/dashboard");
          } else {
            this.gotoLogin();
          }
        } else {
          this.navController.navigateRoot("home");
        }
      });
    });
  }

  gotoLogin() {
    this.userService.navigateHomeToLogin(false, "Login", false);
    this.router.navigateByUrl("login");
  }
}
